module.exports = require("./src/index.ts").default